export { default } from "./StrainTile";
